import {
  ConfirmationDialogConfigurationStoreModel,
  InformationDialogConfigurationStoreModel
} from '../store.model'

export enum ConfirmationDialogActionTypes {
  OPEN = 'OPEN_CONFIRMATION_DIALOG',
  CONFIGURE = 'CONFIGURE_CONFIRMATION_DIALOG',
  CLOSE = 'CLOSE_CONFIRMATION_DIALOG',
  SET_IS_WAITING = 'SET_IS_WAITING__CONFIRMATION_DIALOG'
}

export interface OpenConfirmationDialogAction {
  type: ConfirmationDialogActionTypes
}

export interface CloseConfirmationDialogAction {
  type: ConfirmationDialogActionTypes
}

export interface SetIsWaitingConfirmationDialogAction {
  type: ConfirmationDialogActionTypes
  payload: boolean
}

export interface ConfigureConfirmationDialogAction {
  type: ConfirmationDialogActionTypes
  payload?: ConfirmationDialogConfigurationStoreModel | InformationDialogConfigurationStoreModel
}

export const openConfirmationDialogAction = (): OpenConfirmationDialogAction => {
  return { type: ConfirmationDialogActionTypes.OPEN }
}

export const closeConfirmationDialogAction = (): CloseConfirmationDialogAction => {
  return { type: ConfirmationDialogActionTypes.CLOSE }
}

export const setIsWaitingConfirmationDialogAction = (
  isWaiting: boolean
): SetIsWaitingConfirmationDialogAction => {
  return { type: ConfirmationDialogActionTypes.SET_IS_WAITING, payload: isWaiting }
}

export const configureConfirmationDialogAction = (
  configuration: ConfirmationDialogConfigurationStoreModel | undefined
): ConfigureConfirmationDialogAction => {
  return {
    type: ConfirmationDialogActionTypes.CONFIGURE,
    payload: configuration
  }
}

export const configureInformationDialogAction = (
  configuration: InformationDialogConfigurationStoreModel | undefined
): ConfigureConfirmationDialogAction => {
  return {
    type: ConfirmationDialogActionTypes.CONFIGURE,
    payload: configuration
  }
}
